// extracted by mini-css-extract-plugin
module.exports = {"logoRow":"_2HGtrWpvsYOtb531bVgspT","footNote":"_1BU2JeDgmkJXlms2ZjQd8p","footer":"ZdNV1lsFiyVYhT_DLSh7q"};